import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid } from "@material-ui/core";
import SocketContext from "./function/SocketContext";
import moment from "moment";
import isEmpty from "./store/validation/is-Empty";
import { addToPopup, removeFromPopup } from "./store/actions/popupActions";
import {
  addToAdminPopup,
  removeFromAdminPopup,
} from "./store/actions/adminPopupActions";
import { ORDER_TYPE_NAME, ORDER_ICONS, expIcon } from "./enums/OrderEnums";
import { edit_order_vendor_side, edit_order_vendor_v2 } from "./store/actions/OrderingAction/vendorOrderingAction";
import useSound from "use-sound";
import notifSound from "./assets/sound/Ringer.mp3";
import { vendor_accept_pending_diner } from "./store/actions/dashboardAction/addingAction";
import usePrevious from "./customHooks/usePrevious";
import { Modal } from "react-bootstrap";
import MinCountDown from "./components/reusableComponents/allPopupReusable/tableNumberPopup/MinCountDown";
import {
  rejectingExpRequest,
  rejecting_rsvp_event_request,
  requestExpAccept,
  rsvp_edit_perticular_event_request,
} from "./store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import PopupEditWaitTime from "./components/reusableComponents/allPopupReusable/tableNumberPopup/PopupEditWaitTime";
import { NewInputText } from "./components/reusableComponents/inputReusableComponent/InputBoxComponent";
import InputNumberFunc from "./function/InputNumberFunc";

const Notification = (props) => {
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const [play, { stop, isPlaying }] = useSound(notifSound);
  const [popCount, setPopCount] = useState(0);

  const history = useHistory();

  const popupList = useSelector((state) => state.popupList);
  const prevValue = usePrevious(popupList);

  const adminPopupList = useSelector((state) => state.adminPopupList);
  const prevAdminValue = usePrevious(adminPopupList);

  const [isVendor, setIsVendor] = useState(false);

  const host = window.location.host;
  const role = host.includes("admin") ? "superadmin" : "vendor";

  const dispatch = useDispatch();

  const onChangeRedirectUrl = (data) => {
    let reservatonDate = moment(data?.reservationTime).format("YYYY-MM-DD");
    let todayDate = moment().format("YYYY-MM-DD");
    if (data?.diner_status === "PENDING") {
      return "/pendingdashboard";
    } else if (
      data?.diner_status === "CANCELLED" ||
      data?.diner_status === "REJECTED"
    ) {
      return "/historydashboard";
    } else if (
      (data?.diner_status === "NOTSEATED" &&
        data?.service_type === "SEATING") ||
      (data?.diner_status === "SEATED" && data?.service_type === "SEATING")
    ) {
      return "/seatingdashboard";
    } else if (data?.service_type === "RESERVATION") {
      if (reservatonDate === todayDate) {
        return "/seatingdashboard";
      } else {
        return "/reservationdashboard";
      }
    } else {
      return "/reservationdashboard";
    }
  };

  const onChangeRedirectOrderingUrl = (data) => {
    // let reservatonDate = moment(data?.reservationTime).format("YYYY-MM-DD");
    // let todayDate = moment().format("YYYY-MM-DD");
    if (data?.order_status === 0) {
      return "/orderdashboard/10";
    } else if (data?.order_status === 8 || data?.order_status === 7) {
      return "/orderdashboard/20";
    } else {
      return "/orderdashboard/10";
    }
  };

  const handleClick = (item) => (event) => {
    stop();
    if (item?.redirect) {
      if (item.type === "ORDER") {
        history.push({
          pathname: item?.redirect,
          state: { type: item.data?.order_status == 0 ? 11 : 10 },
        });
      } else if (item.type === "DINER") {
        history.push({
          pathname: onChangeRedirectUrl(item.data),
        });
      }
      else if (item.type === "ExpRequest") {
        history.push({
          pathname: item.redirect,
        });
      }
    }
    dispatch(removeFromPopup(item));
  };

  const handleAdminClick = (item) => (event) => {
    stop();
    if (item?.redirect) {
      if (item.type === "ORDER") {
        history.push({
          pathname: item?.redirect,
          state: { type: item.data?.order_status === 0 ? 11 : null },
        });
      } else if (item.type === "ExpRequest") {
        history.push(item.redirect);
      }
    }
    dispatch(removeFromAdminPopup(item));
  };

  const handleClose = (item) => (event) => {
    if (event) event.stopPropagation();
    stop();
    dispatch(removeFromPopup(item));
  };

  const handleAdminClose = (item) => (event) => {
    if (event) event.stopPropagation();
    stop();
    dispatch(removeFromAdminPopup(item));
  };

  const onSuccessChangeStatus = (item, type) => (event) => {
    if (type === 'SA') dispatch(removeFromAdminPopup(item))
    else dispatch(removeFromPopup(item));
  };

  const handleNotification = (data) => {
    dispatch(addToPopup(data));
    setPopCount(popCount + 1);
    setTimeout(() => {
      stop();
      dispatch(removeFromPopup(data));
    }, 120000);
  };

  const handleAdminNotification = (data) => {
    setTimeout(() => {
      dispatch(addToAdminPopup(data));
      setPopCount(popCount + 1);
      setTimeout(() => {
        stop();
        dispatch(removeFromAdminPopup(data));
      }, 75000);
    }, 45000);
  };

  useEffect(() => {
    if (props.role === "vendor") {
      setIsVendor(true);
    }
  }, [props.role]);

  useEffect(() => {
    if (prevValue?.length < popupList?.length) {
      play();
    }
  }, [popupList]);

  useEffect(() => {
    if (prevAdminValue?.length < adminPopupList?.length) {
      play();
    }
  }, [adminPopupList]);

  /******** @DESC Ordering Timer **********/
  const updatedTimeOrder = moment(props?.ele?.data?.createdAt).add(
    parseInt(props?.ele?.data?.wait_time),
    "minutes"
  );
  let diff = updatedTimeOrder.diff(moment());

  /******** @DESC Seating Timer **********/
  const currentTimeTwo = new Date().getTime();
  const updatedTimeDiner = moment(props?.ele?.data?.wait_time_date).add(
    parseInt(props.ele?.data?.wait_time),
    "minutes"
  );
  let diffTime = new Date(updatedTimeDiner).getTime() - currentTimeTwo;

  useEffect(() => {
    let host = window.location.host;
    let role = "vendor";
    props.socket.service("admin/vendor-user").on("patched", (data) => {
      let showNotif = false;
      if (role === "vendor") {
        showNotif = true;
      }
      if (showNotif) {
        let dinerData = {
          message: "Flagged!",
          type: "FLAGGED",
          id: data._id,
          reason: data.reason,
          comment: data.comment,
          flaggedStatus: data.flaggedStatus,
          initiator: data.initiator,
        };
        handleNotification(dinerData);
      }
    });
    props.socket.service("user-ordering").on("curb_notification", (data) => {
      let showNotif = false;
      if (role === "vendor") {
        showNotif = true;
      }
      if (showNotif) {
        let dinerData = {
          message: "User reached at pick up location",
          type: "CURB",
          id: data._id,
        };
        handleNotification(dinerData);
      }
    });
    props.socket.service("user-ordering").on("curb_arrival", (data) => {
      let showNotif = false;
      if (role === "vendor") {
        showNotif = true;
      }
      if (showNotif) {
        let dinerData = {
          message: "Curbside Order Update",
          type: "CURB_ARRIVAL",
          id: data._id,
          data: data
        };
        handleNotification(dinerData);
      }
    });
    props.socket.service("ticket").on("created", (data) => {
      let showNotif = false;
      if (role !== "vendor") {
        showNotif = true;
      } else if (role === "vendor" && data.vendor_id == auth.VendorUser?._id) {
        showNotif = true;
      }
      if (showNotif) {
        let notifData = {
          message: `A new ticket #${data.ticket_number} has been raised by user.`,
          time: Date.now(),
          type: "TICKET",
          redirect:
            auth.VendorUser?.role === "superadmin"
              ? "/openissuesvendors"
              : "/vendoruseropenissues",
          id: Math.floor(1000 + Math.random() * 9000),
        };
        handleNotification(notifData);
      }
    });


    props.socket.service("expRequest").on("popupNotif", (data) => {
      if (
        data.status === "PENDING" ||
        data?.status === "CANCELLED" || data?.status === 'NOTSEATED'
      ) {
        let showNotif = false;
        if (host.includes('merchant')) {
          showNotif = true;
        }
        const currentTimeTwo = new Date().getTime();
        const updatedTimeDiner = moment(data?.waitTimeDate).add(
          parseInt(data?.waitTime),
          "minutes"
        );
        let diffTime = new Date(updatedTimeDiner).getTime() - currentTimeTwo;
        let adminTime = new Date(updatedTimeDiner).getTime() - currentTimeTwo - 45000;
        let type = data.expType === "SPECIAL" ? "special" : "curated";
        let message = data?.status === "PENDING"
          ? `New ${type} Experience Request`
          : data?.status === "NOTSEATED"
            ? `${type} Experience Request has be Auto Accepted`
            : data?.status === "CANCELLED"
              ? `${type} Experience Request has been Cancelled by Admin`
              : "";
        let time = data.waitTime;
        if (showNotif) {
          let expData = {
            message: message,
            time: Date.now(),
            wait_time: time,
            type: "ExpRequest",
            redirect: `/${type.toLowerCase()}Dashboard/${data.experienceId?._id || data.experienceId}/${data.status === 'PENDING' ? 'pending' : data.status === 'CANCELLED' ? 'history' : 'booking'}`,
            id: data._id,
            data: data,
            diff: diffTime
          };
          handleNotification(expData);
        } else {
          let expData = {
            message: message,
            time: Date.now(),
            type: "ExpRequest",
            redirect: `/superadmin/experience/reports/activity/${data?.status === 'PENDING' ? 'pending' : type.toLowerCase()}`,
            id: data._id,
            data: data,
            role: role,
            diff: adminTime,
          };
          handleAdminNotification(expData);
        }
      }
    });
    props.socket.service("ordering").on("pending_notification", (data) => {
      let showNotif = false;
      if (role === "vendor" && data.order_status !== 9) {
        showNotif = true;
      }
      const currentTimeTwo = new Date().getTime();
      const updatedTimeDiner = moment(data?.wait_time_date).add(
        parseInt(data?.wait_time),
        "minutes"
      );
      let diffTime = new Date(updatedTimeDiner).getTime() - currentTimeTwo;
      let adminTime =
        new Date(updatedTimeDiner).getTime() - currentTimeTwo - 45000;
      let message =
        data?.order_status === 0
          ? "New Order Request"
          : data?.order_status === 1
            ? "Order has been Auto Accepted"
            : "Order has been Cancelled by User";
      if (showNotif) {
        let orderData = {
          message: message,
          time: Date.now(),
          type: "ORDER",
          redirect: onChangeRedirectOrderingUrl(data),
          id: data._id,
          data: data,
          diff: diffTime,
        };
        handleNotification(orderData);
      } else {
        if (data?.order_status === 0) {
          let orderData = {
            message: message,
            time: Date.now(),
            type: "ORDER",
            redirect: "/superadminpendingordersactivity",
            id: data._id,
            data: data,
            role: role,
            diff: adminTime,
          };
          handleAdminNotification(orderData);
        }
      }
    });
    props.socket.service("diner").on("diner_creation", (data) => {
      let showNotif = false;
      if (role === "vendor") {
        showNotif = true;
      }
      const currentTimeTwo = new Date().getTime();
      const updatedTimeDiner = moment(data?.wait_time_date).add(
        parseInt(data?.wait_time),
        "minutes"
      );
      let diffTime = new Date(updatedTimeDiner).getTime() - currentTimeTwo;
      let adminTime =
        new Date(updatedTimeDiner).getTime() - currentTimeTwo - 45000;
      if (showNotif) {
        let dinerData = {
          message:
            data?.diner_status === "PENDING"
              ? "New Seating Request"
              : "New Seating Request has been Auto accepted",
          time: Date.now(),
          type: "DINER",
          // redirect: "/seatingdashboard",
          redirect: onChangeRedirectUrl(data),
          vendor_id: data.vendor_id,
          id: data._id,
          data: data,
          diff: diffTime,
        };
        handleNotification(dinerData);
      } else {
        if (data?.diner_status === "PENDING") {
          let dinerData = {
            message:
              data?.diner_status === "PENDING"
                ? "New Seating Request"
                : "New Seating Request has been Auto accepted",
            time: Date.now(),
            type: "DINER",
            redirect: "/superadminseatingpendingactivityreport",
            vendor_id: data.vendor_id,
            id: data._id,
            data: data,
            diff: adminTime,
          };
          handleAdminNotification(dinerData);
        }
      }
    });
    props.socket.service("diner").on("diner_trigger", (data) => {
      let showNotif = false;
      if (role === "vendor" && data.diner_status === "PENDING") {
        showNotif = true;
      }
      const currentTimeTwo = new Date().getTime();
      const updatedTimeDiner = moment(data?.wait_time_date).add(
        parseInt(data?.wait_time),
        "minutes"
      );
      let diffTime = new Date(updatedTimeDiner).getTime() - currentTimeTwo;
      if (showNotif) {
        let dinerData = {
          message:
            data?.diner_status === "PENDING"
              ? "Seating Request"
              : "Seating Request has been Auto accepted",
          time: Date.now(),
          type: "DINER",
          // redirect: "/seatingdashboard",
          redirect: onChangeRedirectUrl(data),
          vendor_id: data.vendor_id,
          id: data._id,
          data: data,
          diff: diffTime,
        };
        handleNotification(dinerData);
      }
    });
    props.socket.service("user/diner").on("patched", (data) => {
      if (data.diner_status === "CANCELLED") {
        let showNotif = false;
        if (role === "vendor") {
          showNotif = true;
        }
        if (showNotif) {
          let dinerData = {
            message: "Seating request has been cancelled by User",
            time: Date.now(),
            type: "DINER",
            redirect: onChangeRedirectUrl(data),
            // redirect:
            //   data?.diner_status === "CANCELLED" ||
            //   data?.diner_status === "REJECTED"
            //     ? "/historydashboard"
            //     : "/seatingdashboard",
            id: data._id,
            data: data,
          };
          handleNotification(dinerData);
        }
      }
    });
  }, [props.socket]);

  const [showWait, setShowWait] = useState(false);
  const [waitTime, setWaitTime] = useState(5);

  const handleSubmit = (item) => {
    let formData = {
      diner_status: "NOTSEATED",
      wait_time: waitTime,
    };
    dispatch(
      vendor_accept_pending_diner(
        formData,
        item.data._id,
        item.data.vendor_id,
        auth.accessToken,
        onSuccessChangeStatus(item, 'VENDOR')
      )
    );
    setShowWait(false);
  };

  const handleAccept = (item, type) => (event) => {
    stop();
    event.stopPropagation();
    if (item.type === "ORDER") {
      let formData = {
        id: item.id,
        order_status: 1,
        next: true
      };
      dispatch(
        edit_order_vendor_v2(
          auth.accessToken,
          formData,
          onSuccessChangeStatus(item, type)
        )
      );
    } else if (
      item.type === "DINER" &&
      item.data?.service_type === "RESERVATION"
    ) {
      let formData = {
        diner_status: "NOTSEATED",
      };
      if (item.data?.service_type === "SEATING") {
        formData.wait_time = 5;
      }
      dispatch(
        vendor_accept_pending_diner(
          formData,
          item.data._id,
          item.data.vendor_id,
          auth.accessToken,
          onSuccessChangeStatus(item, type)
        )
      );
    } else if (item.type === "EVENT") {
      let formData = {
        event_status: "NOTSEATED",
      };
      dispatch(
        rsvp_edit_perticular_event_request(
          formData,
          item.data?._id,
          auth.accessToken,
          onSuccessChangeStatus(item, type)
        )
      );
    } else if (item.type === "ExpRequest") {
      let formData = {
        status: "NOTSEATED",
        target: "POPUP"
      };
      dispatch(
        requestExpAccept(
          formData,
          item.data?._id,
          auth.accessToken,
          onSuccessChangeStatus(item, type)
        )
      );
    } else if (item.type === "DINER" && item.data?.service_type === "SEATING") {
      setShowWait(true);
    }
  };

  const handleReject = (item, type) => (event) => {
    event.stopPropagation();
    stop();
    if (item.type === "ORDER") {
      let formData = {
        id: item.id,
        order_status: 8,
        reason: "Rejected by Vendor",
        max_time: 0,
      };
      dispatch(
        edit_order_vendor_side(
          auth.accessToken,
          formData,
          onSuccessChangeStatus(item, type)
        )
      );
    } else if (item.type === "DINER") {
      let formData = {
        diner_status: "REJECTED",
        cancelReason: "Cancelled by Vendor",
      };
      dispatch(
        vendor_accept_pending_diner(
          formData,
          item.data._id,
          item.vendor_id,
          auth.accessToken,
          onSuccessChangeStatus(item, type)
        )
      );
    } else if (item.type === "EVENT") {
      let formData = {
        status: "REJECTED",
        cancelReason: "Rejected by Vendor",
        refundPercentage: 100
      };
      dispatch(
        rejectingExpRequest(
          formData,
          item.data?._id,
          auth.accessToken,
          onSuccessChangeStatus(item, type)
        )
      );
    } else if (item.type === "ExpRequest") {
      let formData = {
        status: "REJECTED",
        cancelReason: "Rejected by Vendor",
        refundPercentage: 100,
        target: 'POPUP'
      };
      dispatch(
        rejectingExpRequest(
          formData,
          item.data?._id,
          auth.accessToken,
          onSuccessChangeStatus(item, type)
        )
      );
    }
  };

  return (
    <>
      {popupList.length ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // zIndex: 9990,
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          {popupList.map((ele, index) => (
            <>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "#fff",
                  borderRadius: "6px",
                  boxShadow: "0px 2px 4px #0000004",
                  minWidth: "400px",
                }}
                key={index}
              >
                <div
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "4px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#000000",
                    cursor: "pointer",
                  }}
                  onClick={handleClose(ele)}
                >
                  X
                </div>
                <Modal.Header>
                  <Modal.Title>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        {ele?.message}
                      </div>
                      <div
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "4px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#4D4D4D",
                          cursor: "pointer",
                        }}
                        onClick={handleClose(ele)}
                      >
                        X
                      </div>
                    </div>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Grid container direction="column">
                    {ele.type === "FLAGGED" && (
                      <>
                        <Grid
                          item
                          className="p2 f10-400"
                          style={{
                            color: "#EE3A23",
                            margin: "10px",
                          }}
                        >
                          Admin flagged you for below reason. Complete your
                          ongoing requests.
                        </Grid>
                        <Grid
                          item
                          className="p2 f10-500"
                          style={{
                            // color: "#EE3A23",
                            margin: "10px",
                          }}
                        >
                          Flag Reason: {ele.reason}
                        </Grid>
                        <Grid
                          item
                          className="p2 f10-500"
                          style={{
                            // color: "#EE3A23"
                            margin: "10px",
                          }}
                        >
                          Flag Comments: {ele.comment}
                        </Grid>
                        <Grid
                          item
                          className="p2 f10-500"
                          style={{
                            color: "#EE3A23",
                            margin: "10px",
                          }}
                        >
                          <Button
                            variant="outline-secondary"
                            className="btn-lg mr-4 px-5"
                            onClick={handleClose(ele)}
                          >
                            Closed
                          </Button>
                        </Grid>
                      </>
                    )}
                    {ele.type === "TICKET" && (
                      <>
                        <Grid
                          item
                          className="p2 f10-400"
                          style={{
                            color: "#EE3A23",
                            margin: "10px",
                          }}
                        >
                          {moment(ele.time).format("lll")}
                        </Grid>
                        <Grid
                          item
                          className="p2 f14-400"
                          style={{ margin: "10px" }}
                        >
                          {ele.message}
                        </Grid>
                      </>
                    )}
                    {ele.type === "CURB" && (
                      <>
                        <Grid
                          item
                          className="p2 f10-400"
                          style={{
                            color: "#EE3A23",
                            margin: "10px",
                          }}
                        >
                          {moment(ele.time).format("lll")}
                        </Grid>
                        <Grid
                          item
                          className="p2 f14-400"
                          style={{ margin: "10px" }}
                        >
                          {ele.message}
                        </Grid>
                      </>
                    )}
                    {ele.type === "CURB_ARRIVAL" && (
                      <>
                        <Grid
                          item
                          className="p2 f14-400"
                          style={{ margin: "10px" }}
                        >
                          Order ID #{ele.data?.order_id}
                        </Grid>
                        <Grid
                          item
                          className="p2 f14-400"
                          style={{ margin: "10px" }}
                        >
                          {`The User is ${(Number(ele.data?.curb_side_details?.approxDist) / 1000).toFixed(2)} KMS away from Curbside pickup location.`}
                        </Grid>
                        <Grid
                          item
                          className="p2 f14-700"
                          style={{ margin: "10px" }}
                        >
                          ETA : {(Number(ele.data?.curb_side_details?.approxTime) / 60).toFixed()} Mins
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          style={{ margin: "4px 4px 12px 12px" }}
                        >
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Grid item>
                              <button
                                onClick={handleClick(ele)}
                                color={"default"}
                                className="btn btn-outline-secondary mr-2"
                              >
                                View Details
                              </button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    )}
                    {ele.type === "ORDER" && (
                      <>
                        <div>
                          <table className="f12-400" cellSpacing="15">
                            <tr>
                              <td>Order Type - </td>
                              <th>{ORDER_TYPE_NAME[ele?.data?.order_type]} {`${(ele?.data?.delivery_partner === 2 && ele?.data?.order_type === 7) ? 'Dunzo' : ''}`}</th>
                            </tr>
                            <tr>
                              <td>User Name - </td>
                              <th>
                                {ele?.data?.user_details?.first_name}{" "}
                                {ele?.data?.user_details?.last_name}
                              </th>
                            </tr>
                            <tr>
                              <td>Phone Number - </td>
                              <th>
                                {ele?.data?.user_details?.country_code}{" "}
                                {ele?.data?.user_details?.mobile_number}
                              </th>
                            </tr>
                            <tr>
                              <td>
                                No. Of Items -{" "}
                                {ele?.data?.order_items?.length || 0}{" "}
                              </td>
                              <td>
                                Payment Status -{" "}
                                {ele?.data?.payment_status === 1
                                  ? "Paid"
                                  : "Unpaid"}
                              </td>
                            </tr>
                            {(ele?.data?.delivery_partner === 2 && ele?.data?.order_type === 7) ? <tr>
                              <td>Distance - </td>
                              <th>
                                {ele?.data?.delivery_quote?.distance}
                              </th>
                            </tr> : <></>}
                          </table>
                          <div
                            className="p-2 mt-2 mb-2"
                            style={{ backgroundColor: "#d0d0d052" }}
                          >
                            <Grid
                              container
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Grid item className={"m2"}>
                                <img
                                  src={ORDER_ICONS[ele.data?.order_type]}
                                  width="35px"
                                />
                              </Grid>
                              {ele?.data?.order_status === 0 && (
                                <Grid item className="ml-2">
                                  Accept within{" "}
                                  <span
                                    style={{
                                      color: "#EE3A23",
                                    }}
                                    className="f12-400"
                                  >
                                    <MinCountDown waitNew={ele.diff} />
                                  </span>
                                </Grid>
                              )}
                            </Grid>
                          </div>
                          <Grid
                            item
                            xs={12}
                            style={{ margin: "4px 4px 12px 12px" }}
                          >
                            <Grid
                              container
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Grid item>
                                {ele?.data?.order_status === 0 &&
                                  ele.role !== "vendor" && (
                                    <button
                                      onClick={handleReject(ele, 'VENDOR')}
                                      className="btn btn-danger mr-2"
                                      style={{ border: "3px solid #ee3a23" }}
                                    >
                                      Reject
                                    </button>
                                  )}
                                <button
                                  onClick={handleClick(ele)}
                                  color={"default"}
                                  className="btn btn-outline-secondary mr-2"
                                >
                                  View Details
                                </button>
                                {ele?.data?.order_status === 0 &&
                                  ele.role !== "vendor" && (
                                    <button
                                      className="btn btn-success"
                                      type="button"
                                      style={{ border: "3px solid #28a745" }}
                                      onClick={handleAccept(ele, 'VENDOR')}
                                    >
                                      Accept
                                    </button>
                                  )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </div>
                      </>
                    )}
                    {ele.type === "DINER" && (
                      <div>
                        <table className="f12-400" cellSpacing="15">
                          <tbody>
                            <tr>
                              <td>Request Type - </td>
                              <th>
                                {ele?.data?.service_type === "RESERVATION"
                                  ? "Reservation"
                                  : "Seating"}
                              </th>
                            </tr>
                            <tr>
                              <td>User Name - </td>
                              <th>{ele?.data?.user_details?.name || ""}</th>
                            </tr>
                            <tr>
                              <td>Phone Number - </td>
                              <th>
                                {ele?.data?.user_details?.country_code}{" "}
                                {ele?.data?.user_details?.mobile_number}
                              </th>
                            </tr>
                            <tr>
                              <td>Party Size - </td>
                              <td>
                                <span className="f12-500">
                                  Kids - {ele?.data?.kids_count}
                                </span>
                              </td>
                              <td>
                                <span className="f12-500">
                                  Adults - {ele?.data?.adult_count}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Date -{" "}
                                {ele?.data?.service_type === "RESERVATION"
                                  ? moment(ele?.data?.reservationTime).format(
                                    "ll"
                                  )
                                  : moment(ele?.data?.createdAt).format("ll")}
                                &nbsp;
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Time -{" "}
                                {ele?.data?.service_type === "RESERVATION"
                                  ? moment(ele?.data?.reservationTime).format(
                                    "hh:mm A"
                                  )
                                  : moment(ele?.data?.createdAt).format(
                                    "hh:mm A"
                                  )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          className="p-2 mt-2 mb-2"
                          style={{ backgroundColor: "#d0d0d052" }}
                        >
                          <Grid
                            container
                            justifyContent="start"
                            alignItems="center"
                          >
                            {/* <Grid item className={"m2"}>
                              <img
                                src={ORDER_ICONS[ele.data?.order_type]}
                                width="35px"
                              />
                            </Grid> */}
                            {ele?.data?.diner_status === "PENDING" && (
                              <Grid item className="ml-2">
                                Accept within{" "}
                                <span
                                  style={{
                                    color: "#EE3A23",
                                  }}
                                  className="f12-400 pl-2"
                                >
                                  <MinCountDown waitNew={ele.diff} />
                                </span>
                              </Grid>
                            )}
                          </Grid>
                        </div>
                        <Grid
                          item
                          xs={12}
                          style={{ margin: "4px 4px 12px 12px" }}
                        >
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Grid item>
                              {ele?.data?.diner_status === "PENDING" && (
                                <button
                                  onClick={handleReject(ele, "VENDOR")}
                                  className="btn btn-danger mr-2 my-1"
                                  style={{ border: "3px solid #ee3a23" }}
                                >
                                  Reject
                                </button>
                              )}
                              <button
                                onClick={handleClick(ele)}
                                color={"default"}
                                className="btn btn-outline-secondary mr-2 my-1"
                              >
                                View Details
                              </button>
                              {ele?.data?.diner_status === "PENDING" && (
                                <button
                                  className="btn btn-success my-1"
                                  type="button"
                                  style={{ border: "3px solid #28a745" }}
                                  onClick={handleAccept(ele, "VENDOR")}
                                >
                                  {ele?.data?.service_type === "SEATING"
                                    ? "Select Wait Time"
                                    : "Accept"}
                                </button>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                        {showWait && (
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Grid item>
                              <div className="d-flex align-items-center">
                                <NewInputText
                                  extraClass="mb-0"
                                  name="enter_wait_time"
                                  inputType="number"
                                  onKeyDown={InputNumberFunc}
                                  maxLength="10"
                                  onChange={(e) => setWaitTime(e.target.value)}
                                  value={waitTime}
                                  labelText="Enter Wait Time"
                                  controlClass={"outlined-helperText "}
                                />
                                <p className="minu-section ml-2 m-0">Mins</p>
                              </div>
                            </Grid>
                            <Grid item>
                              <button
                                className="btn btn-success"
                                type="button"
                                style={{ border: "3px solid #28a745" }}
                                onClick={(e) => handleSubmit(ele)}
                              >
                                Accept
                              </button>
                            </Grid>
                          </Grid>
                        )}
                      </div>
                    )}
                    {ele.type === "EVENT" && (
                      <div>
                        <table class="f12-400" cellSpacing="15">
                          <tbody>
                            <tr>
                              <td>Request Type - </td>
                              <th>
                                {ele?.data?.event_type === "RSVP"
                                  ? "RSVP"
                                  : "Ticket Booking"}
                              </th>
                            </tr>
                            <tr>
                              <td>User Name - </td>
                              <th>{ele?.data?.user_details?.name || ""}</th>
                            </tr>
                            <tr>
                              <td>Phone Number - </td>
                              <th>
                                {ele?.data?.user_details?.country_code}{" "}
                                {ele?.data?.user_details?.mobile_number}
                              </th>
                            </tr>
                            <tr>
                              <td>Party Size - </td>
                              <td>
                                <span className="f12-500">
                                  Kids - {ele?.data?.kids_count}
                                </span>
                              </td>
                              <td>
                                <span className="f12-500">
                                  Adults - {ele?.data?.adult_count}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          className="p-2 mt-2 mb-2"
                          style={{ backgroundColor: "#d0d0d052" }}
                        >
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            {/* <Grid item className={"m2"}>
                              <img
                                src={ORDER_ICONS[ele.data?.order_type]}
                                width="35px"
                              />
                            </Grid> */}
                            {ele?.data?.event_status === "PENDING" && (
                              <Grid item className="ml-2">
                                Accept within{" "}
                                <span
                                  style={{
                                    color: "#EE3A23",
                                  }}
                                  className="f12-400"
                                >
                                  <MinCountDown waitNew={ele.diff} />
                                </span>
                              </Grid>
                            )}
                          </Grid>
                        </div>
                        <Grid
                          item
                          xs={12}
                          style={{ margin: "4px 4px 12px 12px" }}
                        >
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Grid item>
                              {ele?.data?.event_status === "PENDING" && (
                                <button
                                  onClick={handleReject(ele, 'VENDOR')}
                                  className="btn btn-danger mr-2"
                                  style={{ border: "3px solid #ee3a23" }}
                                >
                                  Reject
                                </button>
                              )}
                              <button
                                onClick={handleClick(ele)}
                                color={"default"}
                                className="btn btn-outline-secondary mr-2"
                              >
                                View Details
                              </button>
                              {ele?.data?.event_status === "PENDING" && (
                                <button
                                  className="btn btn-success"
                                  type="button"
                                  style={{ border: "3px solid #28a745" }}
                                  onClick={handleAccept(ele, 'VENDOR')}
                                >
                                  Accept
                                </button>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </div>
                    )}
                    {ele.type === "ExpRequest" && (
                      <div>
                        <table class="f12-400" >
                          <tbody className="my-4">
                            <tr className="my-4">
                              <td>User Name : </td>
                              <th>{ele?.data?.userDetails?.name || ""}</th>
                            </tr>
                            <tr className="my-4">
                              <td>Experience Name : </td>
                              <th>{ele?.data?.experienceId?.name || ""}</th>
                            </tr>
                            <tr className="my-4">
                              <td>Experience ID : </td>
                              <th>{ele?.data?.experienceId?.expId || ""}</th>
                            </tr>
                            <tr className="my-4">
                              <td>PAX Count :</td>
                              <th>{ele?.data?.adultCount + ele?.data?.package?.adults} Adults {`${(ele.data?.kidsCount || ele?.data?.package?.kids) ? `${ele.data?.kidsCount + ele?.data?.package?.kids} Kids` : ""} `}</th>
                            </tr>
                            <tr className="my-4">
                              <td>Total Ticket Price : </td>
                              <th>{ele?.data?.paymentData?.totalAmount}/-</th>
                            </tr>
                            <tr className="my-4">
                              <td>Payment Status :</td>
                              <th>
                                {ele?.data?.paymentStatus === 1
                                  ? "PAID"
                                  : ele?.data?.paymentStatus === 0
                                    ? "UNPAID"
                                      : "N/A"}
                              </th>
                            </tr>
                          </tbody>
                        </table>
                        <div
                          className="p-2 mt-2 mb-2"
                          style={{ backgroundColor: "#d0d0d052" }}
                        >
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <Grid item className={"m2"}>
                              <img
                                src={expIcon}
                                width="35px"
                              />
                            </Grid>
                            {ele?.data?.status === 'PENDING' && (
                              <Grid item className="ml-2">
                                Accept within{" "}
                                <span
                                  style={{
                                    color: "#EE3A23",
                                  }}
                                  className="f12-400"
                                >
                                  <MinCountDown waitNew={ele.diff} />
                                </span>
                              </Grid>
                            )}
                          </Grid>
                        </div>
                        <Grid
                          item
                          xs={12}
                          style={{ margin: "4px 4px 12px 12px" }}
                        >
                          <Grid
                            container
                            justifyContent="space-between"
                            alignItems="center"
                            className="mt-4"
                          >

                            {ele?.data?.status === "PENDING" && (
                              <Grid item>
                                <button
                                  onClick={handleReject(ele, 'VENDOR')}
                                  className="btn btn-danger"
                                  style={{ border: "3px solid #ee3a23", minWidth: "100px" }}
                                >
                                  Reject
                                </button>
                              </Grid>
                            )}
                            <Grid item>
                              <button
                                onClick={handleClick(ele)}
                                color={"default"}
                                className="btn btn-outline-secondary"
                                style={{ minWidth: "100px" }}
                              >
                                View Details
                              </button>
                            </Grid>
                            {ele?.data?.status === "PENDING" && (
                              <Grid item>
                                <button
                                  className="btn btn-success"
                                  type="button"
                                  style={{ border: "3px solid #28a745", minWidth: "100px" }}
                                  onClick={handleAccept(ele, 'VENDOR')}
                                >
                                  Accept
                                </button>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </div>
                    )}
                  </Grid>
                </Modal.Body>
              </div>
            </>
          ))}
        </div >
      ) : (
        <></>
      )
      }
      {
        adminPopupList.length ? (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              // zIndex: 9990,
              backgroundColor: "rgba(0,0,0,0.5)",
            }}
          >
            {adminPopupList.map((ele, index) => (
              <>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "#fff",
                    borderRadius: "6px",
                    boxShadow: "0px 2px 4px #0000004",
                    minWidth: "400px",
                  }}
                  key={index}
                >

                  <Modal.Header>
                    <Modal.Title>{ele?.message}
                      <div
                        style={{
                          position: "absolute",
                          right: "8px",
                          top: "4px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#000000",
                          cursor: "pointer",
                        }}
                        onClick={handleAdminClose(ele)}
                      >
                        X
                      </div></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Grid container direction="column">
                      {ele.type === "ORDER" && (
                        <>
                          <div>
                            <table className="f12-400" cellSpacing="15">
                              <tbody>
                                <tr>
                                  <td>Order Type - </td>
                                  <th>
                                    {ORDER_TYPE_NAME[ele?.data?.order_type]}
                                  </th>
                                </tr>
                                <tr>
                                  <td>User Name - </td>
                                  <th>
                                    {ele?.data?.user_details?.first_name}{" "}
                                    {ele?.data?.user_details?.last_name}
                                  </th>
                                </tr>
                                <tr>
                                  <td>Phone Number - </td>
                                  <th>
                                    {ele?.data?.user_details?.country_code}{" "}
                                    {ele?.data?.user_details?.mobile_number}
                                  </th>
                                </tr>
                                <tr>
                                  <td>
                                    No. Of Items -{" "}
                                    {ele?.data?.order_items?.length || 0}{" "}
                                  </td>
                                  <td>
                                    Payment Status -{" "}
                                    {ele?.data?.payment_status === 1
                                      ? "Paid"
                                      : "Unpaid"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div
                              className="p-2 mt-2 mb-2"
                              style={{ backgroundColor: "#d0d0d052" }}
                            >
                              <Grid
                                container
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Grid item className={"m2"}>
                                  <img
                                    src={ORDER_ICONS[ele.data?.order_type]}
                                    width="35px"
                                  />
                                </Grid>
                                {ele?.data?.order_status === 0 && (
                                  <Grid item className="ml-2">
                                    Accept within{" "}
                                    <span
                                      style={{
                                        color: "#EE3A23",
                                      }}
                                      className="f12-400"
                                    >
                                      <MinCountDown waitNew={ele.diff} />
                                    </span>
                                  </Grid>
                                )}
                              </Grid>
                            </div>
                            <Grid
                              item
                              xs={12}
                              style={{ margin: "4px 4px 12px 12px" }}
                            >
                              <Grid
                                container
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Grid item>
                                  <button
                                    onClick={handleAdminClick(ele)}
                                    color={"default"}
                                    className="btn btn-outline-secondary mr-2"
                                  >
                                    View Details
                                  </button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </div>
                        </>
                      )}
                      {ele.type === "DINER" && (
                        <div>
                          <table className="f12-400" cellSpacing="15">
                            <tbody>
                              <tr>
                                <td>Request Type - </td>
                                <th>
                                  {ele?.data?.service_type === "RESERVATION"
                                    ? "Reservation"
                                    : "Seating"}
                                </th>
                              </tr>
                              <tr>
                                <td>User Name - </td>
                                <th>{ele?.data?.user_details?.name || ""}</th>
                              </tr>
                              <tr>
                                <td>Phone Number - </td>
                                <th>
                                  {ele?.data?.user_details?.country_code}{" "}
                                  {ele?.data?.user_details?.mobile_number}
                                </th>
                              </tr>
                              <tr>
                                <td>Party Size - </td>
                                <td>
                                  <span className="f12-500">
                                    Kids - {ele?.data?.kids_count}
                                  </span>
                                </td>
                                <td>
                                  <span className="f12-500">
                                    Adults - {ele?.data?.adult_count}
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Date -{" "}
                                  {ele?.data?.service_type === "RESERVATION"
                                    ? moment(ele?.data?.reservationTime).format(
                                      "ll"
                                    )
                                    : moment(ele?.data?.createdAt).format("ll")}
                                  &nbsp;
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  Time -{" "}
                                  {ele?.data?.service_type === "RESERVATION"
                                    ? moment(ele?.data?.reservationTime).format(
                                      "hh:mm A"
                                    )
                                    : moment(ele?.data?.createdAt).format(
                                      "hh:mm A"
                                    )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div
                            className="p-2 mt-2 mb-2"
                            style={{ backgroundColor: "#d0d0d052" }}
                          >
                            <Grid
                              container
                              justifyContent="start"
                              alignItems="center"
                            >
                              {/* <Grid item className={"m2"}>
                              <img
                                src={ORDER_ICONS[ele.data?.order_type]}
                                width="35px"
                              />
                            </Grid> */}
                              {ele?.data?.diner_status === "PENDING" && (
                                <Grid item className="ml-2">
                                  Accept within{" "}
                                  <span
                                    style={{
                                      color: "#EE3A23",
                                    }}
                                    className="f12-400 pl-2"
                                  >
                                    <MinCountDown waitNew={ele.diff} />
                                  </span>
                                </Grid>
                              )}
                            </Grid>
                          </div>
                          <Grid
                            item
                            xs={12}
                            style={{ margin: "4px 4px 12px 12px" }}
                          >
                            <Grid
                              container
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Grid item>
                                <button
                                  onClick={handleClick(ele)}
                                  color={"default"}
                                  className="btn btn-outline-secondary mr-2 my-1"
                                >
                                  View Details
                                </button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </div>
                      )}
                      {ele.type === "ExpRequest" && (
                        <div>
                          <table class="f12-400">
                            <tbody>
                              <tr className="d-flex pb-2">
                                <td>User Name : </td>
                                <th>{ele?.data?.userDetails?.name || ""}</th>
                              </tr>
                              <tr className="d-flex pb-2">
                                <td>Experience Name : </td>
                                <th>{ele?.data?.experienceId?.name || ""}</th>
                              </tr>
                              <tr className="d-flex pb-2">
                                <td>Experience ID : </td>
                                <th>{ele?.data?.experienceId?.expId || ""}</th>
                              </tr>
                              <tr className=" d-flex mb-2">
                                <td>PAX Count :</td>
                                <th>{ele?.data?.adultCount} Adults {`${ele.data?.kidsCount ? `${ele.data?.kidsCount} Kids` : ""} `}</th>
                              </tr>
                              <tr className="d-flex mb-2">
                                <td>Total Ticket Price : </td>
                                <th>{ele?.data?.paymentData?.totalAmount}/-</th>
                              </tr>
                              <tr className="d-flex mb-2">
                                <td>Payment Status :</td>
                                <th>Paid</th>
                              </tr>
                            </tbody>
                          </table>
                          <div
                            className="p-2 mt-2 mb-2"
                            style={{ backgroundColor: "#d0d0d052" }}
                          >
                            <Grid
                              container
                              justifyContent="space-between"
                              alignItems="center"
                            >
                              <Grid item className={"m2"}>
                                <img
                                  src={expIcon}
                                  width="35px"
                                />
                              </Grid>
                              {ele?.data?.status === 'PENDING' && (
                                <Grid item className="ml-2">
                                  Accept within{" "}
                                  <span
                                    style={{
                                      color: "#EE3A23",
                                    }}
                                    className="f12-400"
                                  >
                                    <MinCountDown waitNew={ele.diff} />
                                  </span>
                                </Grid>
                              )}
                            </Grid>
                          </div>
                          <Grid
                            item
                            xs={12}
                            style={{ margin: "4px 4px 12px 12px" }}
                          >
                            <Grid
                              container
                              justifyContent="space-between"
                              alignItems="center"
                              className="mt-4"
                            >

                              {ele?.data?.status === "PENDING" && (
                                <Grid item>
                                  <button
                                    onClick={handleReject(ele, 'SA')}
                                    className="btn btn-danger"
                                    style={{ border: "3px solid #ee3a23", minWidth: "100px" }}
                                  >
                                    Reject
                                  </button>
                                </Grid>
                              )}
                              <Grid item>
                                <button
                                  onClick={handleAdminClick(ele)}
                                  color={"default"}
                                  className="btn btn-outline-secondary"
                                  style={{ minWidth: "100px" }}
                                >
                                  View Details
                                </button>
                              </Grid>
                              {ele?.data?.status === "PENDING" && (
                                <Grid item>
                                  <button
                                    className="btn btn-success"
                                    type="button"
                                    style={{ border: "3px solid #28a745", minWidth: "100px" }}
                                    onClick={handleAccept(ele, 'SA')}
                                  >
                                    Accept
                                  </button>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        </div>
                      )}
                    </Grid>
                  </Modal.Body>
                </div>
              </>
            ))}
          </div>
        ) : (
          <></>
        )
      }
    </>
  );
};

const NotificationPopup = (props) => (
  <SocketContext.Consumer>
    {(socket) => <Notification {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default NotificationPopup;
